import React from 'react';
import styled, { css } from 'styled-components';
import Progress from '@clds/progress';
import { Icon } from '@cld/icon';

const expandedCss = css`
  ${Icon} {
    transform: rotate(90deg);
  }
`;

const StyledToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${Icon} {
    transform: rotate(0);
    transition: transform 150ms ease-in-out;
  }

  ${({ expanded }) => expanded && expandedCss};
`;

const ToggleButton = ({ size, progress, onClick, expanded, toggleIcon }) => {
  return (
    <StyledToggle size={size} onClick={onClick} expanded={expanded && !progress}>
      {progress ? <Progress.Circular size="sm" /> : toggleIcon}
    </StyledToggle>
  );
};

export default ToggleButton;
